import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Button } from "@/components/ui/button";
import * as Icons from "lucide-react";
import { ObjectFields } from "./ObjectFields";

// One site_content section: header (name, order, hidden) + every field.
// fixed = the page has a set design: its sections are text groups, so order/hide don't apply.
export function SectionCard({ section, index, total, onChange, onMove, onDragStart, onDropAt, fixed = false }) {
  const [open, setOpen] = useState(index === 0);
  const [over, setOver] = useState(false);
  const name = section.name || `section-${index + 1}`;
  return (
    <Card className={`border-border/70 ${section.hidden ? "opacity-60" : ""} ${over ? "ring-2 ring-primary" : ""}`} data-testid={`cms-section-${name}`}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); onDropAt?.(index); }}>
      <div className="flex items-center gap-3 px-4 py-3">
        {!fixed && <span draggable onDragStart={(e) => { e.dataTransfer.effectAllowed = "move"; onDragStart?.(index); }} className="cursor-grab active:cursor-grabbing text-muted-foreground" title="Drag to reorder" data-testid={`cms-drag-${name}`}><Icons.GripVertical className="h-4 w-4" /></span>}
        <button className="flex-1 flex items-center gap-2 text-left min-w-0" onClick={() => setOpen((o) => !o)} data-testid={`cms-section-toggle-${name}`}>
          <Icons.ChevronRight className={`h-4 w-4 text-muted-foreground transition-transform ${open ? "rotate-90" : ""}`} />
          <span className="font-mono text-[11px] text-muted-foreground w-6">{section.position ?? index + 1}</span>
          <span className="font-heading font-semibold text-foreground">{name}</span>
          <span className="text-xs text-muted-foreground truncate">{[section.eyebrow, section.headline || section.heading].filter(Boolean).join(" · ")}</span>
        </button>
        {!fixed && <>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          Hidden <Switch checked={!!section.hidden} onCheckedChange={(v) => onChange({ ...section, hidden: v })} data-testid={`cms-hidden-${name}`} />
        </div>
        <Button size="icon" variant="ghost" className="h-7 w-7" disabled={index === 0} onClick={() => onMove(-1)} data-testid={`cms-section-up-${name}`}><Icons.ArrowUp className="h-3.5 w-3.5" /></Button>
        <Button size="icon" variant="ghost" className="h-7 w-7" disabled={index === total - 1} onClick={() => onMove(1)} data-testid={`cms-section-down-${name}`}><Icons.ArrowDown className="h-3.5 w-3.5" /></Button>
        </>}
      </div>
      {open && <div className="px-4 pb-4 border-t border-border pt-4">
        {section.note && <p className="mb-3 text-xs rounded-lg bg-muted/60 text-muted-foreground px-3 py-2" data-testid={`cms-note-${name}`}>{section.note}</p>}
        <ObjectFields obj={section} onChange={onChange} path={name} skip={["position", "hidden", "name", "note"]} />
      </div>}
    </Card>
  );
}
